/**
 * EventsScriptApi — the `engine.events` capability module (global service).
 *
 * Scoped pub/sub for gameplay events. Exercises `@scriptEvent` (`on` returns an
 * `Unsubscribe` handle) alongside `@scriptFn` (`emit`) so the codegen projects both kinds
 * into the generated interface. Backing is injected per runtime (DI).
 */

import { scriptApi, scriptEvent, scriptFn } from "../scriptApi";
import type { Unsubscribe } from "../IEngineContext";

/** The injected event-bus backing (DI per runtime). */
export interface EventsBacking {
  emit(eventId: string, payload?: Record<string, unknown>): void;
  on(eventId: string, handler: (payload?: Record<string, unknown>) => void): Unsubscribe;
}

@scriptApi("events", { tier: "safe", version: 1 })
export class EventsScriptApi {
  constructor(private readonly _backing: EventsBacking) {}

  @scriptFn() emit(eventId: string, payload?: Record<string, unknown>): void {
    this._backing.emit(eventId, payload);
  }

  @scriptEvent() on(
    eventId: string,
    handler: (payload?: Record<string, unknown>) => void,
  ): Unsubscribe {
    return this._backing.on(eventId, handler);
  }
}
